import { useState } from "react";
import { cambiarContrasena, validarNueva } from "../../features/auth/authService";
import { botonPrimario, botonSecundario, campo, etiqueta } from "../estilos";
import Modal from "./Modal";

// Cambiar la propia contraseña (Supabase Auth): se confirma la actual.
function CambiarPassword({ onCerrar }) {
  const [form, setForm] = useState({ actual: "", nueva: "", repetir: "" });
  const [error, setError] = useState("");
  const [listo, setListo] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    setError("");
    const problema = validarNueva(form.nueva, form.repetir);
    if (problema) return setError(problema);
    setGuardando(true);
    try {
      await cambiarContrasena(form.actual, form.nueva);
      setListo(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setGuardando(false);
    }
  };

  const campoDe = (clave, texto, autoComplete) => (
    <div>
      <label htmlFor={`pw-${clave}`} className={etiqueta}>{texto}</label>
      <input id={`pw-${clave}`} type="password" autoComplete={autoComplete} value={form[clave]}
        onChange={(e) => setForm({ ...form, [clave]: e.target.value })} className={campo} />
    </div>
  );

  return (
    <Modal titulo="Cambiar contraseña" onCerrar={onCerrar}>
      {listo ? (
        <>
          <p className="text-sm text-gray-300">Tu contraseña quedó actualizada. Úsala la próxima vez que entres.</p>
          <button onClick={onCerrar} className={`${botonPrimario} mt-6 w-full`}>Listo</button>
        </>
      ) : (
        <>
          <div className="space-y-4">
            {campoDe("actual", "Contraseña actual", "current-password")}
            {campoDe("nueva", "Nueva contraseña", "new-password")}
            {campoDe("repetir", "Repite la nueva contraseña", "new-password")}
          </div>
          {error && <p role="alert" className="mt-4 text-sm text-red-300">{error}</p>}
          <div className="mt-6 flex gap-3">
            <button onClick={guardar} disabled={guardando} className={`${botonPrimario} flex-1`}>
              {guardando ? "Guardando..." : "Guardar"}
            </button>
            <button onClick={onCerrar} className={`${botonSecundario} flex-1`}>Cancelar</button>
          </div>
        </>
      )}
    </Modal>
  );
}

export default CambiarPassword;
